import React from 'react';
import { View, TouchableOpacity, StyleSheet, ScrollView, ActivityIndicator } from 'react-native';
import { Color, CommonProperties } from '../../../styles';
import { selectCreditCards } from '../../../store/selectors/expense.selector';
import { useDispatch, useSelector } from 'react-redux';
import BaseText from '../../BaseText';
import { PaymentTypes, setExpenseValue } from '../../../store/actions/expense';

const PaymentModal = ({ route, navigation }) => {
  const { stateName, actionType, subTab } = route.params;
  const dispatch = useDispatch();
  const creditCardsList = useSelector(selectCreditCards);

  const handleCardSelect = (value) => {
    dispatch(
      setExpenseValue({
        actionType,
        subTab,
        key: stateName,
        value: { text: value.text, value: value.value },
      })
    );
    navigation.goBack();
  };

  const renderCardOrCashList = (cards, sectionHeader) => (
    <>
      <BaseText style={styles.sectionHeader}>{sectionHeader}</BaseText>
      <View style={styles.divider} />
      {cards.map((card) => (
        <React.Fragment key={card.Value}>
          <TouchableOpacity
            style={[styles.cardButton, card.IsExpired && styles.expiredCard]}
            onPress={() => handleCardSelect({ text: card.Text, value: card.Value })}
            disabled={card.IsExpired}
          >
            <BaseText style={styles.cardText}>
              {!card.IsExpired ? card.Text : `${card.Text} - Expired`}
            </BaseText>
          </TouchableOpacity>
          <View style={styles.divider} />
        </React.Fragment>
      ))}
    </>
  );

  return (
    <ScrollView>
      {creditCardsList ? (
        <>
          {renderCardOrCashList(creditCardsList.corporate, PaymentTypes.COMPANY_CARDS)}
          {renderCardOrCashList(creditCardsList.personal, PaymentTypes.PERSONAL_CARDS)}
          {renderCardOrCashList(creditCardsList.cash, PaymentTypes.CASH)}
        </>
      ) : (
        <View style={CommonProperties.flexCenter}>
          <ActivityIndicator size="large" color={Color.primary} />
        </View>
      )}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  sectionHeader: {
    ...CommonProperties.h2,
    color: Color.disabled,
    ...CommonProperties.py4,
    ...CommonProperties.px3,
  },
  cardButton: {
    ...CommonProperties.px5,
    ...CommonProperties.py4,
  },
  expiredCard: {
    backgroundColor: Color.disabled,
  },
  cardText: {
    ...CommonProperties.h3,
    color: Color.black,
  },
  divider: {
    height: 1,
    backgroundColor: Color.grayText,
  },
});

export default PaymentModal;
